import { render, staticRenderFns } from "./StDrs.vue?vue&type=template&id=7ff5068e"
import script from "./StDrs.vue?vue&type=script&lang=ts"
export * from "./StDrs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports